import { render, staticRenderFns } from "./receipt-cfg-page-dialog.vue?vue&type=template&id=21282fdf&scoped=true&"
import script from "./receipt-cfg-page-dialog.vue?vue&type=script&lang=js&"
export * from "./receipt-cfg-page-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21282fdf",
  null
  
)

export default component.exports